import { render, staticRenderFns } from "./DocsUploader.vue?vue&type=template&id=14f24afa&scoped=true"
import script from "./DocsUploader.vue?vue&type=script&lang=js"
export * from "./DocsUploader.vue?vue&type=script&lang=js"
import style0 from "./DocsUploader.vue?vue&type=style&index=0&id=14f24afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f24afa",
  null
  
)

export default component.exports